import React from 'react'

const NotificationIcon = ({ height, width }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
                fill: 'currentColor',
                height: height,
                overflow: 'hidden',
                verticalAlign: 'middle',
                width: width,
            }}
            viewBox="0 0 36.5 36.5"
        >
            <rect style={{ fill: '#ccc' }} x=".04" y=".04" width="36.42" height="36.42" rx="9.04" ry="9.04" />
            <path style={{ strokeWidth: 0, fill: '#fff' }} d="M6.63,22.82c3.84,0,4.47-5.5,4.47-9.47s5.07-6.72,5.07-6.72c0-2.03,2.08-2.08,2.08-2.08,0,0,2.08.04,2.08,2.08,0,0,5.07,2.75,5.07,6.72,0,3.98.63,9.47,4.47,9.47v2.68s-5.13,1.21-11.39,1.21h0c-6.26,0-11.85-1.21-11.85-1.21" />
            <path style={{ strokeWidth: 0, fill: '#fff' }} d="M13.9,27.6s.35,4.36,4.24,4.36,4.45-4.38,4.45-4.38c0,0-1.65.17-4.35.17s-4.35-.15-4.35-.15Z" />
        </svg>
    )
}


export default NotificationIcon
